module.exports = __webpack_public_path__ + "static/media/madhucon8.ba70868b.png";